<template>
  <div
    class="modal_wrap bottom_modal internet_filter_modal"
    :class="{ on: show }"
    id="modal_wrap"
  >
    <div class="modal_inner" v-if="show" id="modal_inner">
      <div class="modal" ref="modal" id="filter_modal" @scroll="onScroll">
        <div class="close_txt">
          <p class="pnt" @click="close(false)">
            닫기<img
              :src="require('@/assets/front/images/i_x_pop_s.png')"
              alt=""
            />
          </p>
        </div>
        <div class="main_con">
          <div class="con_top_wrap">
            <div class="con_top" id="con_top" ref="con_top">
              <div class="con_title">
                필터 선택하기
              </div>
              <div class="con_tab_li">
                <ul>
                  <li
                    class="tab_li"
                    :class="{ on: filterSelTab == 'tab_0' }"
                    id="tab_0"
                    @click="tabSel('tab_0')"
                  >
                    상품 구성
                  </li>
                  <li
                    class="tab_li"
                    :class="{ on: filterSelTab == 'tab_1' }"
                    id="tab_1"
                    @click="tabSel('tab_1')"
                  >
                    인터넷 속도
                  </li>
                  <li
                    class="tab_li"
                    :class="{ on: filterSelTab == 'tab_2' }"
                    id="tab_2"
                    @click="tabSel('tab_2')"
                  >
                    통신사
                  </li>
                  <li
                    class="tab_li"
                    :class="{ on: filterSelTab == 'tab_3' }"
                    id="tab_3"
                    @click="tabSel('tab_3')"
                  >
                    가격대
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="con_section_wrap" ref="con_section_wrap">
            <div class="con_section pt" ref="tab_0" id="sec_0">
              <div class="sec_title">
                상품 구성
              </div>
              <div class="sec_item">
                <label
                  v-for="(item, index) in itemTypes"
                  :key="index"
                  class="pnt"
                >
                  <input
                    type="radio"
                    :name="item.name"
                    :value="item.value"
                    v-model="selectItem[0]"
                  />
                  <div class="txt"></div>
                  <div class="txt02" :title="item.label">{{ item.label }}</div>
                </label>
              </div>
            </div>
            <div class="con_section_div" ref="con_section_div"></div>
            <div class="con_section" ref="tab_1" id="sec_1">
              <div class="sec_title">
                인터넷 속도<span>(중복선택가능)</span>
              </div>
              <div class="sec_item">
                <label
                  v-for="(item, index) in speedTypes"
                  :key="index"
                  class="pnt"
                >
                  <input
                    type="checkbox"
                    :name="item.name"
                    :value="item.value"
                    v-model="selectSpeed"
                    @click="funSelectSpeed(item.value)"
                  />
                  <div class="txt"></div>
                  <div class="txt02" :title="item.label">{{ item.label }}</div>
                </label>
              </div>
            </div>
            <div class="con_section_div" ref="con_section_div"></div>
            <div class="con_section" ref="tab_2" id="sec_2">
              <div class="sec_title">통신사<span>(중복선택가능)</span></div>
              <div class="sec_item">
                <label
                  v-for="(item, index) in telecomTypes"
                  :key="index"
                  class="pnt"
                >
                  <input
                    type="checkbox"
                    :name="item.name"
                    :value="item.value"
                    v-model="selectTelecom"
                    @click="funSelectTelecom(item.value)"
                  />
                  <div class="txt"></div>
                  <div class="txt02" :title="item.label">{{ item.label }}</div>
                </label>
              </div>
            </div>
            <div class="con_section_div" ref="con_section_div"></div>
            <div class="con_section" ref="tab_3" id="sec_3">
              <div class="sec_title">가격대<span>(중복선택가능)</span></div>
              <div class="sec_item sec_item2">
                <label
                  v-for="(item, index) in priceTypes"
                  :key="index"
                  class="pnt"
                >
                  <input
                    type="checkbox"
                    :name="item.name"
                    :value="item.value"
                    v-model="selectPrice"
                    @click="funSelectPrice(item.value)"
                  />
                  <div class="txt"></div>
                  <div class="txt02" :title="item.label">{{ item.label }}</div>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="btm_btn">
          <div class="btn_wrap" ref="btn_wrap">
            <button class="btn bo pnt reset" @click.stop.prevent="reset">
              <i class="i_filter_reset"></i>필터 초기화
            </button>
            <button class="btn pnt" @click.stop.prevent="close(true)">
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div
        class="made_toast_layer_common"
        style="bottom:7rem;"
        v-if="isViewToast"
      >
        <div class="toast_msg">{{ errorMessage }}</div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'InternetFilter',
  description: '인터넷 필터',
  props: {
    show: Boolean,
    filterSelTab: {
      type: String,
      default: 'tab_0',
    },
  },
  computed: {},
  data() {
    return {
      selectItem: ['internetNtv'],
      itemTypes: [
        { name: 'item_1', label: '인터넷 + TV', value: 'internetNtv' },
        { name: 'item_2', label: '인터넷', value: 'internet' },
      ],
      selectSpeed: ['ALL'], // 선택한 값
      speedTypes: [
        { name: 'speed_1', label: '전체', value: 'ALL' },
        { name: 'speed_2', label: '100M', value: '100M' },
        { name: 'speed_3', label: '160M', value: '160M' },
        { name: 'speed_4', label: '200M', value: '200M' },
        { name: 'speed_5', label: '320M', value: '320M' },
        { name: 'speed_6', label: '500M', value: '500M' },
        { name: 'speed_7', label: '1G 이상', value: 'GIGA' },
      ],
      selectTelecom: ['ALL'], // 선택한 값
      telecomTypes: [
        { name: 'telecom_1', label: '전체', value: 'ALL' },
        { name: 'telecom_2', label: 'SKT', value: 'SKT' },
        { name: 'telecom_3', label: 'KT', value: 'KT' },
        { name: 'telecom_4', label: 'LGU+', value: 'LGUPLUS' },
        { name: 'telecom_5', label: 'SKB', value: 'SKB' },
        { name: 'telecom_6', label: 'KT skylife', value: 'SKYLIFE' },
        { name: 'telecom_7', label: 'LG헬로비전', value: 'HELLO' },
        // { name: 'telecom_8', label: '딜라이브', value: '딜라이브' },
        // { name: 'telecom_9', label: 'HCN', value: 'HCN' },
        // { name: 'telecom_10', label: 'SKB 알뜰', value: 'SKB 알뜰' },
        // { name: 'telecom_11', label: 'CMB', value: 'CMB' },
        // { name: 'telecom_12', label: 'NIB남인천', value: 'NIB남인천' },
        // { name: 'telecom_13', label: '성남아름방송', value: '성남아름방송' },
        // { name: 'telecom_14', label: 'SCC충북', value: 'SCC충북' },
        // { name: 'telecom_15', label: 'KCN금강', value: 'KCN금강' },
        // { name: 'telecom_16', label: '푸른방송', value: '푸른방송' },
        // { name: 'telecom_17', label: 'JCN울산', value: 'JCN울산' },
        // { name: 'telecom_18', label: '서경방송', value: '서경방송' },
        // { name: 'telecom_19', label: 'KCTV광주', value: 'KCTV광주' },
        // { name: 'telecom_20', label: 'KCTV제주', value: 'KCTV제주' },
      ],
      selectPrice: ['ALL'], // 선택한 값
      priceTypes: [
        { name: 'price_1', label: '전체', value: 'ALL' },
        { name: 'price_2', label: '1만원 이하', value: 'U_10000' },
        { name: 'price_3', label: '1만원 ~ 2만원', value: 'B_10000_20000' },
        { name: 'price_4', label: '2만원 ~ 3만원', value: 'B_20000_30000' },
        { name: 'price_5', label: '3만원 ~ 5만원', value: 'B_30000_50000' },
        { name: 'price_6', label: '5만원 이상', value: 'O_50000' },
      ],
      isViewToast: false,
      errorMessage: '',
      fileterSelTab: this.filterSelTab,
    };
  },
  watch: {
    filterSelTab() {
      this.$nextTick(function() {
        this.tabSel(this.filterSelTab);
      });
    },
  },
  methods: {
    close(dataType) {
      if (dataType) {
        if (this.selectSpeed.length < 1) {
          this.errorMessage = '인터넷 속도를 선택해주세요';
          this.toastView();
          return;
        }
        if (this.selectTelecom.length < 1) {
          this.errorMessage = '통신사를 선택해주세요';
          this.toastView();
          return;
        }
        if (this.selectPrice.length < 1) {
          this.errorMessage = '가격대를 선택해주세요';
          this.toastView();
          return;
        }
      }
      this.$emit(
        'close',
        dataType,
        this.selectItem,
        this.selectSpeed,
        this.selectTelecom,
        this.selectPrice,
      );
    },
    reset() {
      this.selectItem.splice(0);
      this.selectItem.push('internetNtv');

      this.selectSpeed.splice(0);
      this.selectSpeed.push('ALL');

      this.selectTelecom.splice(0);
      this.selectTelecom.push('ALL');

      this.selectPrice.splice(0);
      this.selectPrice.push('ALL');

      this.$refs.tab_0.scrollIntoView({ behavior: 'smooth' });
    },
    funSelectItem(val) {
      const findItem = this.selectItem.findIndex(element => element == val);

      console.log('findItem = {}', findItem);

      // 선택한 값이 없을 경우
      if (findItem === -1) {
        // ALL일 경우
        if (val == this.itemTypes[0].value) {
          this.selectItem.splice(0);
        } else {
          const findAllItem = this.selectItem.findIndex(
            element => element == this.itemTypes[0].value,
          );

          if (findAllItem >= 0) {
            this.selectItem.splice(findAllItem, 1);
          }
        }

        this.selectItem.push(val);
      } else {
        // 선택한 값이 있을 경우
        this.selectItem.splice(findItem, 1);
      }
      console.log(this.selectItem);
    },
    funSelectSpeed(val) {
      const findSpeed = this.selectSpeed.findIndex(element => element == val);

      console.log('findSpeed = {}', findSpeed);

      // 선택한 값이 없을 경우
      if (findSpeed === -1) {
        // ALL일 경우
        if (val == this.speedTypes[0].value) {
          this.selectSpeed.splice(0);
        } else {
          const findAllSpeed = this.selectSpeed.findIndex(
            element => element == this.speedTypes[0].value,
          );

          if (findAllSpeed >= 0) {
            this.selectSpeed.splice(findAllSpeed, 1);
          }
        }

        this.selectSpeed.push(val);
      } else {
        // 선택한 값이 있을 경우
        this.selectSpeed.splice(findSpeed, 1);
      }
      console.log(this.selectSpeed);
    },
    funSelectTelecom(val) {
      const findTelecom = this.selectTelecom.findIndex(
        element => element == val,
      );

      console.log('findTelecom = {}', findTelecom);

      // 선택한 값이 없을 경우
      if (findTelecom === -1) {
        // ALL일 경우
        if (val == this.telecomTypes[0].value) {
          this.selectTelecom.splice(0);
        } else {
          const findAllTelecom = this.selectTelecom.findIndex(
            element => element == this.telecomTypes[0].value,
          );

          if (findAllTelecom >= 0) {
            this.selectTelecom.splice(findAllTelecom, 1);
          }
        }

        this.selectTelecom.push(val);
      } else {
        // 선택한 값이 있을 경우
        this.selectTelecom.splice(findTelecom, 1);
      }
      console.log(this.selectTelecom);
    },
    funSelectPrice(val) {
      const findPrice = this.selectPrice.findIndex(element => element == val);

      console.log('findTelecom = {}', findPrice);

      // 선택한 값이 없을 경우
      if (findPrice === -1) {
        // ALL일 경우
        if (val == this.priceTypes[0].value) {
          this.selectPrice.splice(0);
        } else {
          const findAllPrice = this.selectPrice.findIndex(
            element => element == this.priceTypes[0].value,
          );

          if (findAllPrice >= 0) {
            this.selectPrice.splice(findAllPrice, 1);
          }
        }

        this.selectPrice.push(val);
      } else {
        // 선택한 값이 있을 경우
        this.selectPrice.splice(findPrice, 1);
      }
      console.log(this.selectPrice);
    },
    tabSel(id) {
      let con_top_height = this.$refs.con_top.offsetHeight;
      let modal_height = this.$refs.modal.offsetHeight;
      let con_tab_0_height = this.$refs.tab_0.offsetHeight;
      let con_tab_1_height = this.$refs.tab_1.offsetHeight;
      let con_tab_2_height = this.$refs.tab_2.offsetHeight;
      let con_tab_3_height = this.$refs.tab_3.offsetHeight;
      let con_section_div_height = this.$refs.con_section_div.offsetHeight;

      var idElement = document.getElementById(id);
      var classElement = document.querySelector('.tab_li.on');

      classElement.classList.remove('on');
      idElement.classList.add('on');

      if (id == 'tab_0') {
        this.$refs.tab_0.scrollIntoView({ behavior: 'auto' });
      } else if (id == 'tab_1') {
        this.$refs.modal.scrollTo({
          top: con_tab_0_height - con_top_height,
          behavior: 'auto',
        });
      } else if (id == 'tab_2') {
        this.$refs.modal.scrollTo({
          top:
            con_tab_0_height +
            con_tab_1_height +
            con_section_div_height -
            con_top_height,
          behavior: 'auto',
        });
      } else if (id == 'tab_3') {
        this.$refs.modal.scrollTo({
          top:
            con_tab_0_height +
            con_tab_1_height +
            con_tab_2_height +
            con_section_div_height -
            con_top_height,
          behavior: 'auto',
        });
      }
    },
    toastView() {
      this.isViewToast = true;
      setTimeout(() => {
        this.isViewToast = false;
      }, 2000);
    },
    onScroll(e) {
      let modal_height = this.$refs.modal.offsetHeight;
      let con_top_height = this.$refs.con_top.offsetHeight;
      let con_tab_0_height = this.$refs.tab_0.offsetHeight;
      let con_tab_1_height = this.$refs.tab_1.offsetHeight;
      let con_tab_2_height = this.$refs.tab_2.offsetHeight;
      let con_tab_3_height = this.$refs.tab_3.offsetHeight;
      let con_section_div_height = this.$refs.con_section_div.offsetHeight;
      let btn_wrap_height = this.$refs.btn_wrap.offsetHeight;

      let id = 'tab_0';

      const scroll = document.getElementById('filter_modal').scrollTop;

      console.log(' ================= ');
      console.log('scroll = ' + scroll);
      console.log('modal_height = ' + modal_height);
      console.log('con_top_height = ' + con_top_height);
      console.log('con_tab_0_height = ' + con_tab_0_height);
      console.log('con_tab_1_height = ' + con_tab_1_height);
      console.log('con_tab_2_height = ' + con_tab_2_height);
      console.log('con_tab_3_height = ' + con_tab_3_height);
      console.log('con_section_div_height = ' + con_section_div_height);
      console.log('btn_wrap_height = ' + btn_wrap_height);
      console.log(' ================= ');

      if (
        con_tab_0_height +
          con_tab_1_height +
          con_section_div_height +
          20 -
          con_top_height <=
        scroll
      ) {
        id = 'tab_3';
      } else if (
        con_tab_0_height +
          con_tab_1_height +
          con_section_div_height -
          con_top_height <=
        scroll
      ) {
        id = 'tab_2';
      } else if (con_tab_0_height - con_top_height <= scroll) {
        id = 'tab_1';
      }

      const idElement = document.getElementById(id);
      const classElement = document.querySelector('.tab_li.on');
      classElement.classList.remove('on');
      idElement.classList.add('on');
    },
    bottomCheck(event) {
      const { scrollTop, offsetHeight, scrollHeight } = event.target;
      if (scrollTop + offsetHeight >= scrollHeight) {
        return true;
      }
    },
  },
};
</script>
<style lang="scss"></style>
